import { createSlice } from '@reduxjs/toolkit';
import categoryApi from '../../api/categoryApi';
import { logout } from '../auth/index';

const initialState = {
  categories: [],
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
  },
  extraReducers: {
    [logout]: (state) => initialState,
  },
});

export const { setCategories } = categoriesSlice.actions;

export const getCategories = (state) => state.categories.categories;

const getFamilyLine = (category) => {
  let arrIds = [];
  if (category?._id) {
    arrIds.push(category._id);
    if (category?.children?.length) {
      let childrenIds = [];
      let i = 0;
      while (i < category.children.length) {
        childrenIds = childrenIds.concat(getFamilyLine(category.children[i]));
        i += 1;
      }
      arrIds = arrIds.concat(childrenIds);
    }
  }
  return arrIds;
};

export const getCategoryByLevel = (arr, level) => {
  let i = 0;
  let options = [];
  while (i < arr.length) {
    const option = {
      ...arr[i],
      value: arr[i]._id,
      label: arr[i].name,
      level,
      familyLine: getFamilyLine(arr[i]),
    };
    delete options.children;
    if (arr?.[i]?.children?.length) {
      options = [
        ...options,
        option,
        ...getCategoryByLevel(arr?.[i].children, level + 1),
      ];
    } else {
      options.push(option);
    }
    i += 1;
  }
  return options;
};

export const getCategoriesAsync = () => async (dispatch) => {
  const categories = await categoryApi.get();
  return dispatch(setCategories(getCategoryByLevel(categories, 0)));
};

export default categoriesSlice.reducer;
